import { motion } from 'framer-motion'
import { CgWebsite } from 'react-icons/cg'
import { BsGithub } from 'react-icons/bs'

function ProjectCard({ imgPath, title, description, ghLink, demoLink, isBlog }) {
  return (
    <motion.div
      whileHover={{ y: -10 }}
      className="group relative h-full bg-gradient-to-br from-dark-light to-dark-lighter rounded-xl overflow-hidden border border-purple-900/30 hover:border-purple-500/50 transition-all duration-300 shadow-lg hover:shadow-2xl hover:shadow-purple-500/20"
    >
      {/* Glow Effect */}
      <div className="absolute inset-0 bg-gradient-to-r from-purple-600/0 via-purple-600/5 to-pink-600/0 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
      
      {/* Image Container */}
      <div className="relative overflow-hidden">
        <img
          src={imgPath}
          alt={title}
          className="w-full h-56 object-cover transform group-hover:scale-110 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-dark via-dark/50 to-transparent opacity-60" />
      </div>

      {/* Content */}
      <div className="relative p-6 space-y-4">
        <h3 className="text-2xl font-bold text-white group-hover:text-purple-400 transition-colors duration-300">
          {title}
        </h3>
        
        <p className="text-gray-300 text-sm leading-relaxed line-clamp-4">
          {description}
        </p>

        {/* Buttons */}
        <div className="flex gap-4 pt-4">
          {ghLink && (
            <motion.a
              href={ghLink}
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="flex items-center gap-2 px-5 py-2.5 bg-purple-600 hover:bg-purple-700 text-white rounded-lg font-medium transition-all duration-300 hover:shadow-lg hover:shadow-purple-500/50"
            >
              <BsGithub className="text-lg" />
              <span>{isBlog ? 'Blog' : 'GitHub'}</span>
            </motion.a>
          )}

          {!isBlog && demoLink && (
            <motion.a
              href={demoLink}
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="flex items-center gap-2 px-5 py-2.5 bg-gradient-to-r from-pink-600 to-purple-600 hover:from-pink-700 hover:to-purple-700 text-white rounded-lg font-medium transition-all duration-300 hover:shadow-lg hover:shadow-pink-500/50"
            >
              <CgWebsite className="text-lg" />
              <span>Live Demo</span>
            </motion.a>
          )}
        </div>
      </div>

      {/* Corner Accent */}
      <div className="absolute top-0 right-0 w-20 h-20 bg-gradient-to-br from-purple-600/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
    </motion.div>
  )
}

export default ProjectCard

